<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold">پاپ‌آپ</h5>
      </div>
      <div class="card-body">
        <Loading v-if="loading" />
        <b-form v-else @submit.prevent="submitHandler" class="row">
          <b-form-group class="col-12 col-md-6">
            <label for="title">عنوان <i class="text-danger">*</i></label>
            <b-form-input id="title" v-model="form.title" type="text"
              placeholder="عنوان پاپ‌آپ را وارد کنید"></b-form-input>
          </b-form-group>

          <b-form-group class="col-12 col-md-6">
            <label for="display_delay">تاخیر نمایش (ثانیه)</label>
            <b-form-input id="display_delay" v-model.number="form.display_delay" type="number" min="0"
              placeholder="مثلا 3"></b-form-input>
          </b-form-group>

          <b-form-group class="col-12">
            <label for="description">توضیحات</label>
            <b-form-textarea id="description" v-model="form.description" placeholder="توضیحات پاپ‌آپ را وارد کنید"
              rows="3"></b-form-textarea>
          </b-form-group>

          <!-- <b-form-group class="col-12 col-md-6">
            <label for="image">تصویر</label>
            <b-form-file id="image" accept="image/*" @change="setImage" size="sm"></b-form-file>
            <a v-if="existingImageUrl" target="_blank" class="d-inline-block mt-2 border border-primary p-1 rounded"
              :href="existingImageUrl">
              <img class="img-thumbnail" width="80" height="80" :src="existingImageUrl" alt="تصویر پاپ‌آپ" />
            </a>
          </b-form-group> -->

          <b-form-group class="col-12 col-md-6">
            <label for="start_date">تاریخ شروع</label>
            <date-picker v-model="form.start_date" format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD"
              placeholder="تاریخ شروع" />
          </b-form-group>

          <b-form-group class="col-12 col-md-6">
            <label for="end_date">تاریخ پایان</label>
            <date-picker v-model="form.end_date" format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD"
              placeholder="تاریخ پایان" />
          </b-form-group>

          <b-form-group class="col-12">
            <b-form-checkbox v-model="form.is_active" switch>
              فعال باشد
            </b-form-checkbox>
          </b-form-group>

          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <label class="mb-0">کدهای تخفیف</label>
              <b-button size="sm" variant="outline-primary" @click="addCoupon">
                + کد تخفیف جدید
              </b-button>
            </div>

            <div v-if="!form.coupon_code || form.coupon_code.length === 0" class="text-muted small mb-3">
              کد تخفیفی اضافه نشده است.
            </div>

            <div v-for="coupon in form.coupon_code" :key="coupon._uid" class="coupon-row row align-items-start mb-2">
              <div class="col-12 col-md-4">
                <ckeditor :id="`coupon-description-${coupon._uid}`" v-model="coupon.code"
                  placeholder="توضیحات این کد تخفیف"></ckeditor>
              </div>
              <div class="col-12 col-md-6 mt-2 mt-md-0">
                <b-form-input v-model="coupon.description" type="text" placeholder="کد تخفیف"></b-form-input>
              </div>  
              <div class="col-12 col-md-2 mt-2 mt-md-0 d-flex">
                <b-button size="sm" variant="outline-danger" class="w-100" @click="removeCoupon(coupon._uid)">
                  حذف
                </b-button>
              </div>
            </div>
          </div>

          <div class="col-12 mt-3">
            <b-button :disabled="disabled" type="submit" variant="primary">
              <span v-if="popupId">ذخیره تغییرات</span>
              <span v-else>ثبت پاپ‌آپ</span>
            </b-button>
          </div>
        </b-form>
      </div>
    </div>
  </main>
</template>
<script>
import PopupImpl from "@@/core/pages/Popup/PopupImpl";
export default {
  extends: PopupImpl,
};
</script>

<style scoped>
.coupon-row {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 0.75rem 0.5rem;
  margin-inline: 0;
}
</style>
